import CloseableModal from "@/components/CloseableModal"
import { BootstrapButton } from "@/components/form"
import { ExportStageType } from "@/models"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"

interface Props {
	onCancelled(): void
	onChosen(type: ExportStageType): void
}

const ExportMarriageClaimsModal: ReactiveComponent<Props> = (props) => {
	return () => (
		<CloseableModal title={`Confirm Export Type`} onClose={props.onCancelled} style={{ width: "48rem" }}>
			<div class="d-flex flex-column gap-1">
				<BootstrapButton color="primary" onClick={() => props.onChosen(ExportStageType.p1)}>
					Download P1 CSV
				</BootstrapButton>
				<BootstrapButton color="primary" onClick={() => props.onChosen(ExportStageType.p2)}>
					Download P2 CSV
				</BootstrapButton>
				<BootstrapButton color="primary" onClick={() => props.onChosen(ExportStageType.allData)}>
					Download Full Data CSV
				</BootstrapButton>
			</div>
		</CloseableModal>
	)
}
export default defineComponent(ExportMarriageClaimsModal, inferProps<Props>())
